import { Form, Formik, FormikProps } from 'formik'
import React, { useRef, useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { useRecoilState, useRecoilValue } from "recoil"
import { userImageDataSelector, userSettingSelected, userSettingTxAtom } from "../atoms/userSetting"
import apiService from "../services/api"
import { useLogger } from "../framework/logger"
import { ArrowLeftCircle as BackIcon } from '../svgicons/ArrowLeftCircle'
import DeleteIcon from '@mui/icons-material/Delete';
import { now } from "../framework/utils/date"
import { useTranslation } from 'react-i18next'
import { UserSetting } from "../models/UserSetting"
import { OptionType } from "../constants/index"
import {
    Accordion, AccordionDetails, AccordionSummary, Autocomplete, AutocompleteChangeReason, Badge, BadgeProps, Box, Button, Checkbox, FormControlLabel, IconButton, List, ListItem, ListItemButton,
    ListItemIcon, ListItemText, Radio, RadioGroup, TextField, Theme, Typography
} from "@mui/material"
import { makeStyles, createStyles } from "@mui/styles"
import { useDropzone } from 'react-dropzone'
import { BrowserUtils } from "../framework/utils"
import Confirm from '../framework/ui/feedback/confirm';
import clsx from 'classnames'
import { userState } from '../atoms'
import { categoryOfUser } from '../atoms/category'
import { Category } from '../models/Category'
import { NotificationCat } from '../models/NotificationCat'
import _ from 'lodash'
import { titlesArea } from '../atoms/menu'
import { areeMySixtemaState } from '../utils/hooks'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => createStyles({
    dropzone: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '1rem',
        borderWidth: 2,
        borderRadius: 2,
        borderColor: '#eeeeee',
        borderStyle: 'dashed',
        backgroundColor: '#fafafa',
        color: '#bdbdbd',
        outline: 'none',
        transition: 'border .24s ease-in-out',
        // marginBottom: '1rem'
    },
    dragActive: {
        borderColor: '#2196f3'
    },
    dragReject: {
        border: 'solid 2px red',
        backgroundColor: '#ffe0e0',
    },
    dragAccept: {
        border: 'solid 2px green',
        backgroundColor: '#e0ffe0',
    },
    file: {
        marginTop: 8,
        cursor: 'pointer'
    },
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    rootList: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: 590,
        //backgroundColor: theme.palette.background.paper,
    },
}))


// const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
//     '& .MuiBadge-badge': {
//         right: '100%',
//         //left: -3,
//         top: -1, //100% per metterla in basso
//         //: 0,
//         border: `2px solid ${theme.palette.background.paper}`,
//         padding: '0 4px',
//     },
// }));

interface Props {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
    submitForm: () => Promise<void>
}

//Component for Upload
const UploadComponent = ({ setFieldValue, submitForm }: Props) => {
    const classes = useStyles()
    
    const { getRootProps, getInputProps, isDragReject, isDragAccept, isDragActive } = useDropzone({
        //accept: "*.png, *.jpg",
        onDrop: (files) => {
            let f = files[0];
            BrowserUtils.convertFileToBase64(f)
                .then((data: string) => {
                    setFieldValue('fileEncoded', data)
                    //Non è disponibile subito il field, devo metterlo con un timeout
                    setTimeout(() => {
                        submitForm()
                    }, 100)
                })
                .catch((err: any) => {
                    // console.log('error', err)
                })
        }
    });

    return (
        <Box>
            <div
                className={clsx(classes.dropzone,
                    isDragActive && classes.dragActive,
                    isDragAccept && classes.dragAccept,
                    isDragReject && classes.dragReject)}
                {...getRootProps()}
            >
                <input title='Drop image here' {...getInputProps()} />
                {isDragActive ? (
                    <p>Drop the files here ...</p>
                ) : (
                    <p>Drag 'n' drop some files here, or click to select files</p>
                )}
            </div>
        </Box>
    );
};

interface DisplayControlProps {
    avatar: string
}
const DisplayControl = ({avatar}: DisplayControlProps) => {        
    const classes = useStyles()
    
    let control = avatar ? (
        <Box sx={{ overflow: 'auto' }}>
            <img src={avatar} style={{ maxWidth: 240 }} alt='Avatar' />
        </Box>
    ) : null;
    return <div className={classes.file}>{control}</div>;
}

function UserSettingPage() {
    const navigate = useNavigate();
    const [, setUserSettingTx] = useRecoilState<number>(userSettingTxAtom)
    const logger = useLogger({ key: 'userSetting' });
    const location = useLocation();
    const idIndex = location.pathname.lastIndexOf('/')
    const username = location.pathname.substring(idIndex + 1)
    const us = useRecoilValue(userSettingSelected)
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [user, setUser] = useRecoilState(userState)
    const [checkedList, setCheckedList] = React.useState([0]);
    const categories = useRecoilValue<Category[]>(categoryOfUser)
    const aree = useRecoilValue<string[]>(areeMySixtemaState)
    const categSelected = useRef<string>('')
    const [immediateList, setImmediateList] = React.useState([0]);
    const immediates = useRef<string>('')
    const avatar = useRecoilValue(userImageDataSelector)
    const classes = useStyles()
    const { t } = useTranslation()
    const giornaliero: string = t('Giornaliero')
    const immediato: string = t('Immediato')
    const [, setExpanded] = React.useState<string | false>('');

    const handleToggle = (value: number, setFieldValue: any) => () => {
        const currentIndex = checkedList.indexOf(value);
        const newChecked = [...checkedList];
        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setCheckedList(newChecked);

        categSelected.current = ''
        newChecked.forEach(x => categSelected.current += x.toString() + ",")
        setFieldValue("categSelected", categSelected.current);
    };

    const getCategories = () => {
        let categories: string = ''
        checkedList.forEach(x => {
            categories += x + ','
        })
        return categories
    }

    const handleImmediate = (value: number, setFieldValue: any) => () => {
        const currentIndex = immediateList.indexOf(value);
        const newImmediate = [...immediateList];
        if (currentIndex === -1) {
            newImmediate.push(value);
        } else {
            newImmediate.splice(currentIndex, 1);
        }
        setImmediateList(newImmediate);

        immediates.current = ''
        newImmediate.forEach(x => immediates.current += x.toString() + ",")
        setFieldValue("immediates", immediates.current);
    };

    const getImmediates = () => {
        let immediates: string = ''
        immediateList.forEach(x => {
            immediates += x + ','
        })
        return immediates
    }

    const handleDelete = (event: React.MouseEvent<HTMLButtonElement>) => {
        setIsDeleteDialogOpen(true);
        event.stopPropagation();
    }
    
    // console.log('username', username);
    const handleBack = () => {
        navigate('/');
    }

    const languages: OptionType[] = [{ value: 'it', label: 'Italiano' }, { value: 'en', label: 'Inglese' }]
    const defaultValue = (options: OptionType[], value: number | string | null) => {
        return options ? options.find(o => o.value === value) : null;
    }

    const updateSetting = (setting: UserSetting) => {
        if (!user) return
        const newUser = _.cloneDeep(user)
        newUser.setting = setting
        // console.log('newUser after setting', newUser)        
        setUser(newUser)
    }

    const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false);
    };

    //I have to load notifications in settings for user
    React.useEffect(() => {
        console.log('us loaded mount', us)
        //setUserSetting(us!)
        if (us.notifications && us.notifications !== '') {
            let notifications: NotificationCat[] = JSON.parse(us.notifications);
            setCheckedList([])
            //fill the checkedList
            let newChecked: number[] = []
            let newImmediate: number[] = []
            if (notifications) {
                notifications.forEach(x => {
                    if (x.id !== 0 && !isNaN(x.id)) {
                        newChecked.push(x.id)
                    }
                    if (x.id !== 0 && !isNaN(x.id) && x.timeType === "I") {
                        newImmediate.push(x.id)
                    }
                })
                setCheckedList(newChecked)
                setImmediateList(newImmediate)
            }
        }
    }, [username, us])

    return (
        <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
            <Box sx={{ display: 'flex', width: '100%', flexDirection: 'row', padding: '10px 0 0 13px' }}>
                <Button onClick={handleBack} title={t('Indietro')}>
                    <BackIcon size={28} />
                </Button>
                <Typography variant="h3">{t('Impostazioni utente')}</Typography>
            </Box>
            <Formik
                initialValues={us}
                onSubmit={(values, { setSubmitting }) => {
                    console.log({ us })
                    if (us?.id === 0) {
                        const insertSetting: UserSetting = {
                            id: 0,
                            // insertUser: us.username,
                            // updateUser: us.username,
                            insertUser: username,
                            updateUser: username,
                            updateDate: now(),
                            language: values.language,
                            //username: us.username,
                            username: username,
                            uiConfig: '',
                            insertDate: now(),
                            avatar: null,
                            fileEncoded: values.fileEncoded,
                            newsConsent: values.newsConsent,
                            applicationConsent: values.applicationConsent,
                            notifications: values.notifications,
                            categSelected: getCategories(),
                            immediates: getImmediates(),
                            marketingConsent: values.marketingConsent,
                            carouselDisabled: values.carouselDisabled
                        }
                        // console.log('Insert User setting', insertSetting)
                        apiService.saveUserSetting(insertSetting).then(setting => {
                            updateSetting(setting)
                            setUserSettingTx(n => n + 1)
                            if (setting) {
                                // console.log('values post insert', values)                            
                                values.id = setting.id
                                //console.log('item added', setting)
                                //navigate('/')
                                logger.info(`Setting: ${setting.username} aggiunto!`);
                            } else {
                                logger.error('Problemi nella creazione del setting');
                            }
                        }).catch(error => {
                            console.error('Error in saving Setting');
                            logger.error(error, 'error');
                        }).finally(() => {
                            setSubmitting(false);
                        })
                    } else {
                        // console.log('Update mode', values)
                        const updValues = {
                            ...values,
                            updateUser: username,
                            updateDate: now(),
                            username: username,
                            insertDate: us?.insertDate,
                            insertUser: us?.insertUser,
                            categSelected: getCategories(),
                            immediates: getImmediates(),
                        }
                        apiService.saveUserSetting(updValues).then(setting => {
                            updateSetting(setting)
                            setUserSettingTx(n => n + 1)
                            if (setting) {
                                // console.log('item updated', setting)
                                //navigate('/')
                                logger.info(`User setting : ${setting.username} aggiornato!`);
                            } else {
                                logger.error('Problemi nel salvataggio del User setting ');
                            }
                        }).catch(error => {
                            console.error('Error in saving User setting ');
                            logger.error(error, 'error');
                        }).finally(() => {
                            setSubmitting(false);
                            //props.onSubmit && props.onSubmit();                            
                        })
                    }
                }}
            //TODO
            //validate={validateForm}
            >
                {(formik: FormikProps<UserSetting>) => {
                    const { values, setFieldValue, submitForm } = formik
                    return (
                        <>
                            <Form style={{ width: '100%', padding: '10px 30px 10px 30px' }}>
                                <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 1 }}>
                                        <Box style={{ marginBottom: '20px', width: '50%', display: 'flex', flexDirection: 'column' }}>
                                            <label htmlFor="language"><b>{t('Lingua')}</b></label>
                                            <Autocomplete
                                                id="language"
                                                options={languages}
                                                getOptionLabel={option => option.label}
                                                //value={{value: values.language, label: getLanguageDesc(values.language)}}
                                                value={defaultValue(languages, values.language)}
                                                onChange={(event: React.SyntheticEvent<Element, Event>, value: OptionType | null, reason: AutocompleteChangeReason) => {
                                                    setFieldValue("language", value?.value);
                                                }}
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        name="language"
                                                        variant="outlined"
                                                        fullWidth
                                                        size='small'
                                                    />
                                                )}
                                            />
                                            {formik.touched.language && formik.errors.language ? (
                                                <div className="invalid-feedback">{formik.errors.language}</div>
                                            )
                                                : null}
                                        </Box>
                                        {/*<Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column' }}>
                                                <label htmlFor="applicationConsent"><b>{t('Accept Terms & Conditions')}</b></label>                                       
                                                <Box sx={{ pt: 1.25, alignSelf: 'center' }}>
                                                    <Field
                                                        id="applicationConsent" 
                                                        name="applicationConsent" 
                                                        type="checkbox" 
                                                    /> 
                                                </Box>
                                            </Box>
                                            <Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column' }}>
                                                <label htmlFor="marketingConsent"><b>{t('Acconsento a ricevere notifiche marketing')}</b></label>                                       
                                                <Box sx={{ pt: 1.25, alignSelf: 'center' }}>
                                                    <Field
                                                        id="marketingConsent" 
                                                        name="marketingConsent" 
                                                        type="checkbox" 
                                                    /> 
                                                </Box>
                                            </Box>
                                            */}
                                    </Box>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 1 }}>
                                        <Box className={classes.root} sx={{ flex: '1 0 33%', gap: '8px' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '4px 8px', border: 'solid 1px #d0d0d0', alignItems: 'center', borderRadius: '4px' }}>
                                                <label htmlFor="avatar"><b>{t('Avatar')}</b></label>
                                                <Box sx={theme => ({ height: 28, width: 28, borderRadius: 14, border: `solid 1px ${theme.palette.primary.main}` })}>
                                                    <IconButton disabled={false} onClick={handleDelete} sx={theme => ({ width: 22, height: 22, mx: 0.25, my: 0.25, color: theme.palette.primary.main })}><DeleteIcon fontSize='small' /></IconButton>
                                                </Box>
                                            </Box>
                                            <Box sx={{border: 'solid 1px #d0d0d0', borderRadius: '4px', padding: '0px 8px', display: 'flex', justifyContent: 'center', alignItems: 'center', flex: '1 0'}}>
                                                {!avatar
                                                    ? <Box>
                                                        <UploadComponent setFieldValue={setFieldValue} submitForm={submitForm} />
                                                    </Box>
                                                    :
                                                    <Box> 
                                                        <DisplayControl avatar={avatar} />
                                                    </Box>
                                                }
                                            </Box>
                                        </Box>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                            <Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column' }}>
                                                <label htmlFor="newsConsent" style={{ paddingLeft: '1%', maxWidth: '600px' }}>
                                                    <b>{t('ACCONSENTO al trattamento dei dati in relazione all’invio da parte del Titolare di comunicazioni ' +
                                                        'commerciali e/o promozionali relative a prodotti/servizi di qualsivoglia natura propri o delle altre ' +
                                                        'società del Gruppo Tinexta.')}
                                                    </b>
                                                </label>
                                                <Box sx={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '1.6%' }}>
                                                    <RadioGroup
                                                        row
                                                        aria-labelledby="radio-buttons-group-label-consenti"
                                                        name='newsConsent'
                                                        value={values.newsConsent ? '1' : '0'}
                                                        onChange={(event: React.ChangeEvent<HTMLInputElement>, value: string) => {
                                                            console.log({ value })
                                                            let consent: boolean = value === '1' ? true : false
                                                            setFieldValue('newsConsent', consent)
                                                        }}
                                                    >
                                                        <FormControlLabel value="1" control={<Radio />} label="Si" />
                                                        <FormControlLabel value="0" control={<Radio />} label="No" />
                                                    </RadioGroup>
                                                    {/* <Checkbox
                                                            name='newsConsent'
                                                            checked={values.newsConsent}
                                                            disableRipple
                                                            onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                                                setFieldValue('newsConsent', checked)
                                                            }}
                                                        /> */}
                                                </Box>
                                            </Box>
                                            
                                                {user?.context?.notifica && 
                                            <Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', mt: 1 }}>
                                                <label htmlFor="category" style={{ paddingLeft: '1%' }}><b>{t('Sono interessato a ricevere notifiche per i seguenti argomenti')}</b></label>
                                                <Box>
                                                    {aree.map((area, index) =>
                                                        categories.filter(x => x.aree.indexOf(area) !== -1) !== null &&
                                                        categories.filter(x => x.aree.indexOf(area) !== -1).length > 0 &&
                                                        (<Accordion key={index} onChange={handleChange(area)} sx={{ width: 'auto' }}>
                                                            <AccordionSummary
                                                                expandIcon={<ExpandMoreIcon />}
                                                                aria-controls="panel1d-content"
                                                                id={area}>
                                                                <Typography><b>{titlesArea[area]}</b></Typography>
                                                            </AccordionSummary>
                                                            <AccordionDetails>
                                                                <List dense className={classes.rootList}>
                                                                    {categories.filter(x => x.aree.indexOf(area) !== -1).map((item) => {
                                                                        const labelId = item.description;
                                                                        return (
                                                                            <ListItem key={item.id}
                                                                                secondaryAction={
                                                                                    <>
                                                                                        <RadioGroup
                                                                                            row
                                                                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                                                                            name="controlled-radio-buttons-group"
                                                                                            value={immediateList.indexOf(item.id) !== -1 ? 'I' : 'D'}
                                                                                            onChange={handleImmediate(item.id, setFieldValue)}
                                                                                        >
                                                                                            <FormControlLabel value="D" control={<Radio />} label={giornaliero} />
                                                                                            <FormControlLabel value="I" control={<Radio />} label={immediato} />
                                                                                        </RadioGroup>
                                                                                    </>
                                                                                }
                                                                                disablePadding
                                                                            >
                                                                                <ListItemButton role={undefined} onClick={handleToggle(item.id, setFieldValue)} sx={{ width: '50%' }}>
                                                                                    <ListItemIcon>
                                                                                        <Checkbox
                                                                                            edge="start"
                                                                                            checked={checkedList.indexOf(item.id) !== -1}
                                                                                            tabIndex={-1}
                                                                                            disableRipple
                                                                                            inputProps={{ 'aria-labelledby': labelId }}
                                                                                        />
                                                                                    </ListItemIcon>
                                                                                    <ListItemText id={labelId}
                                                                                        primary={item.name}
                                                                                    //secondary={getLabelArea(item.aree)}                                                                                     
                                                                                    />
                                                                                </ListItemButton>
                                                                            </ListItem>
                                                                        );
                                                                    })}
                                                                </List>
                                                            </AccordionDetails>
                                                        </Accordion>
                                                        )
                                                    )
                                                    }
                                                </Box>
                                            </Box>
                                                }
                                            
                                        </Box>
                                        <Confirm
                                            open={isDeleteDialogOpen}
                                            onCancel={() => setIsDeleteDialogOpen(false)}
                                            onConfirm={() => {
                                                setFieldValue("avatar", null)
                                                setFieldValue("fileEncoded", null)
                                                submitForm()
                                                //setUserSettingTx(p => p + 1)
                                                setIsDeleteDialogOpen(false);
                                            }}
                                        />
                                    </Box>
                                    {/*
                                        <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 3 }}>
                                            <Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column' }}>
                                                <label htmlFor="applicationConsent"><b>{t('Accept Terms & Conditions')}</b></label>                                       
                                                <Box sx={{ pt: 1.25, alignSelf: 'center' }}>
                                                    <Field
                                                        id="applicationConsent" 
                                                        name="applicationConsent" 
                                                        type="checkbox" 
                                                    /> 
                                                </Box>
                                            </Box>
                                        </Box>
                                        */}
                                    <Box sx={{ display: 'flex', m: '15px 0 0 0' }}>
                                        <Button type="submit" disabled={formik.isSubmitting} title={t('Salva')} variant="outlined">
                                            {formik.isSubmitting ? "Attendere..." : ""}
                                            Salva
                                        </Button>
                                    </Box>
                                </Box>
                            </Form>
                        </>
                    )
                }}
            </Formik>
        </Box>
    )
}

export default UserSettingPage
